import router from '@/router'
import { routerBridge } from '@gto/gw-store'

export const connectRouterBridge = () => {
  routerBridge.on('routeChanged', event => {
    switch (event.route) {
      case 'hands':
        router.push({ name: 'AnalyzeHandsV3' })
        break
      case 'analyzerSettings':
        router.push({ name: 'UserGameSettings' })
        break
      case 'handsStats':
        router.push({
          name: 'AnalyzeHandsV3',
          query: { ...event.query, new_report: 'true', view: 'stats' },
        })
        break
      case 'analyzeHands':
        router.push({
          name: 'AnalyzeHandsV3',
          query: { ...event.query, ...(!event.query?.reportId && { new_report: 'true' }) },
        })
        break
      case 'analyzeUploads':
        router.push({ name: 'AnalyzeFilesV4' })
        break
      case 'analyzeReports':
        router.push({ name: 'GtoReports' })
        break
      case 'subscriptionOverview':
        router.push({
          name: 'SubscriptionOverview',
          ...(Boolean(event.params) && { query: event.params }),
        })
        break
      case 'UserAccount':
        router.push({ name: 'UserAccount' })
        break
      case 'userSubscription':
        router.push({ name: 'UserSubscription' })
        break
      case 'userSubscriptionsOverview':
        router.push({ name: 'UserSubscriptionsOverview' })
        break
      case 'userCredits':
        router.push({ name: 'UserCredits' })
        break
      case 'userSettings':
        router.push({ name: 'UserGameSettings' })
        break
      case 'userAppearance':
        router.push({ name: 'UserAppearance' })
        break
      case 'userHotkeys':
        router.push({ name: 'UserHotkeys' })
        break
      case 'userLanguage':
        router.push({ name: 'UserLanguage' })
        break
      case 'studySolutions':
        router.push({
          name: 'StudySolutions',
          query: { ...router.currentRoute.value.query, soltab: 'strategy' },
        })
        break
      case 'studyReports':
        router.push({
          name: 'StudySolutions',
          query: { ...router.currentRoute.value.query, soltab: 'reports' },
        })
        break
      case 'coaching':
        router.push({ name: 'Coaching' })
        break
      case 'studyPlans':
        router.push({ name: 'StudyPlansDashboard' })
        break
      case 'dashboard':
        router.push({ name: 'Dashboard' })
        break
      case 'play':
        router.push({ name: 'Play' })
        break
      case 'practicePlay':
        router.push({ name: 'PracticePlay' })
        break
      case 'practiceTrainer':
        router.push({ name: 'PracticeTrainer' })
        break
      case 'practiceRangeBuilder':
        router.push({ name: 'PracticeRangeBuilder' })
        break
      case 'practiceDrills':
        router.push({ name: 'PracticeDrills' })
        break
      case 'practiceHands':
        router.push({ name: 'PracticeHands' })
        break
      case 'practiceSessions':
        router.push({ name: 'PracticeSessions' })
        break
      case 'practiceStats':
        router.push({ name: 'PracticeStats' })
        break
      default:
        console.error(`No route found for: ${JSON.stringify(event)}`)
        break
    }
  })
  routerBridge.on('history', event => {
    switch (event.action) {
      case 'back': {
        const goBackPath = router.options.history.state.back

        if (typeof goBackPath === 'string') {
          router.replace(goBackPath)
        } else {
          router.replace({ name: 'Dashboard' })
        }
        break
      }
      case 'forward': {
        const forwardPath = router.options.history.state.forward
        if (typeof forwardPath === 'string') {
          router.replace(forwardPath)
        } else {
          router.replace({ name: 'Dashboard' })
        }
        break
      }
      default:
        console.error(`No history action found for: ${JSON.stringify(event)}`)
        break
    }
  })
}
